// extracted by mini-css-extract-plugin
export var heroImage = "_c1-1";
export var modal = "_c1-0";